"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true if `s` is a String.
 *
 * @example
 * ```ts
 * isString("a"); // true
 * isString(2); // false
 * ```
 */
var isString = function (input) {
    return typeof input === "string";
};
exports.default = isString;
//# sourceMappingURL=isString.js.map